<section id="digitale-fotodokumentation" class="container-fluid">
    <div class="row py-5">
        <div class="my-3 col-xl-5 d-flex justify-content-center align-items-center">
            <img class="responsive-image" src="/assets/img/webp/foto-gis-on-tablet-and-smartphone.webp"
                alt="{{ 'seo.fotoGisOnTabletAndSmartphone' | translate }}">
        </div>
        <div class="my-3 col-xl-5 d-flex align-items-center">
            <div class="row">
                <div class="col-12 py-2 px-3 pt-2">
                    <h1 class="header header--700">{{ 'hero.header' | translate }}</h1>
                </div>
                <div class="col-12 py-2 px-3">
                    <p>{{ 'hero.text' | translate }}</p>
                    <p>{{ 'hero.textAdditional' | translate }}</p>
                </div>
                <div class="col-12 py-2 px-3">
                    <a href="https://pro.foto-gis.eu/" target="_blank" class="btn btn--white-hover m-1">{{
                        'hero.buttonText' | translate }}</a>
                    <a *ngIf="getItem('lang')=='en'" href="/assets/doc/Foto-GIS_en.pdf" target="_blank"
                        class="btn btn--white-hover m-1 padLeft custom-width-40">
                        <div class="mobile-btn">
                            <div class="img-mobile d-flex align-items-center">
                                <i class="far fa-file-pdf"></i>
                            </div>
                            <div class="text-mobile">
                                <span>{{ 'hero.shortVersion' | translate }}</span>
                            </div>
                        </div>
                    </a>
                    <a *ngIf="getItem('lang')=='es'" href="/assets/doc/Foto-GIS_en.pdf" target="_blank"
                        class="btn btn--white-hover m-1 padLeft custom-width-40">
                        <div class="mobile-btn">
                            <div class="img-mobile d-flex align-items-center">
                                <i class="far fa-file-pdf"></i>
                            </div>
                            <div class="text-mobile">
                                <span>{{ 'hero.shortVersion' | translate }}</span>
                            </div>
                        </div>
                    </a>
                    <a *ngIf="getItem('lang')=='fr'" href="/assets/doc/Foto-GIS_fr.pdf" target="_blank"
                        class="btn btn--white-hover m-1 padLeft custom-width-40">
                        <div class="mobile-btn">
                            <div class="img-mobile d-flex align-items-center">
                                <i class="far fa-file-pdf"></i>
                            </div>
                            <div class="text-mobile">
                                <span>{{ 'hero.shortVersion' | translate }}</span>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
        <div class="my-3 col-xl-2 d-flex justify-content-center align-items-center h-300">
            <img class="responsive-image responsive-image--gps" src="/assets/img/webp/foto-gis-pin-map.webp"
                alt="{{ 'seo.fotoGisPinMap' | translate }}">
        </div>
    </div>
</section>
<section id="presentation" class="px-2 px-xl-5 px-md-4 py-5">
    <div class="row d-flex justify-content-center align-items-center m-0">
        <div id="presentation-animation" class="col-xl-6">
            <h2 #opacityAnimation class="header header--300 opacity-animation">
                {{ 'presentation.header' | translate }}
            </h2>
            <br>
            <p #opacityAnimation class="paragraph paragraph--700 mb-0 text-justify opacity-animation">
                {{ 'presentation.textBold' | translate }}
            </p>
            <p #opacityAnimation class="paragraph paragraph--300 text-justify opacity-animation">
                {{ 'presentation.text' | translate }}
            </p>
            <p *ngIf="getItem('lang')=='en'" #opacityAnimation
                class="paragraph paragraph--300 text-justify opacity-animation">
                {{ 'presentation.text1' | translate }}
            </p>
            <p *ngIf="getItem('lang')=='en'" #opacityAnimation
                class="paragraph paragraph--300 text-justify opacity-animation">
                {{ 'presentation.text2' | translate }}
            </p>
        </div>
        <div #opacityAnimation
            class="embed-responsive embed-responsive-16by9 col-xl-6 d-flex justify-content-center align-self-center opacity-animation"
            style="max-width: 100vw !important;">
            <iframe *ngIf="getItem('lang')=='en'" src="https://www.youtube-nocookie.com/embed/aRqlfBPY1yI">
            </iframe>
            <iframe *ngIf="getItem('lang')=='es'" src="https://www.youtube-nocookie.com/embed/aRqlfBPY1yI">
            </iframe>
            <iframe *ngIf="getItem('lang')=='fr'" src="https://www.youtube-nocookie.com/embed/aRqlfBPY1yI">
            </iframe>
        </div>
    </div>
</section>
<section id="system-trio" class="px-2 px-lg-5 px-md-4 py-3 py-lg-5 py-md-4">
    <div class="row m-0 justify-content-around d-flex">
        <div #upAnimation class="card col-lg-4 mx-2 mb-3 text-center up-animation-1">
            <img class="card-img-top m-auto pb-4" src="/assets/img/webp/icon-app.webp"
                alt="{{ 'seo.iconApp' | translate }}">
            <div class="card-body p-0 first-card-body">
                <h3 class="card-title header header--600">{{ 'systemTrio.appHeader' | translate }}</h3>
                <p class="card-text text-justify paragraph--300">{{ 'systemTrio.appText' | translate }}</p>
                <button mat-raised-button class="btn btn-icons" (click)="openModalApp()">
                    <div class="mobile-btn">
                        <div class="img-mobile d-flex align-items-center">
                            <div class="btn-icon-app">
                            </div>
                        </div>
                        <div class="text-mobile">
                            <span>{{'systemTrio.appDialogButton' | translate }}</span>
                        </div>
                    </div>
                </button>
                <a href="https://apps.apple.com/app/foto-gis/id1249212248" target="_blank" class="btn mobile-app">
                    <div class="mobile-btn">
                        <div class="img-mobile d-flex align-items-center">
                            <div class="btn-icon-apple">
                            </div>
                        </div>
                        <div class="text-mobile">
                            <span>{{ 'systemTrio.appleShop' | translate }}</span>
                        </div>
                    </div>
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.app.fotogis" target="_blank"
                    class="btn mobile-app first">
                    <div class="mobile-btn">
                        <div class="img-mobile d-flex align-items-center">
                            <div class="btn-icon-android">
                            </div>
                        </div>
                        <div class="text-mobile">
                            <span>{{ 'systemTrio.androidShop' | translate }}</span>
                        </div>
                    </div>
                </a>
            </div>
        </div>
        <div #upAnimation class="card col-lg-4 mx-2 mb-3 text-center up-animation-2">
            <img class="card-img-top m-auto pb-4" src="/assets/img/webp/icon-organizer.webp"
                alt="{{ 'seo.iconOrganizer' | translate }}">
            <div class="card-body p-0">
                <h3 class="card-title header header--600">{{ 'systemTrio.organizerHeader' | translate }}</h3>
                <p class="card-text text-justify paragraph paragraph--300">{{ 'systemTrio.organizerText' | translate }}
                </p>
                <button mat-raised-button class="btn btn-icons" (click)="openModalOrganizer()">
                    <div class="mobile-btn">
                        <div class="img-mobile d-flex align-items-center">
                            <div class="btn-icon-organizer">
                            </div>
                        </div>
                        <div class="text-mobile">
                            <span>{{ 'systemTrio.organizerDialogButton' | translate }}</span>
                        </div>
                    </div>
                </button>
                <a href="https://pro.foto-gis.eu" class="btn" target="_blank">
                    <div class="mobile-btn">
                        <div class="img-mobile d-flex align-items-center">
                            <i class="fas fa-arrow-right"></i>
                        </div>
                        <div class="text-mobile">
                            <span>{{ 'systemTrio.organizerTestVersionText'
                                | translate }}</span>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</section>
<section id="no-more" class="px-2 px-xl-5 px-md-4 py-5">
    <div class="row m-0">
        <div #fromSideAnimation class="col-xl-6 d-flex justify-content-center from-left-animation">
            <img src="/assets/img/webp/foto-gis-on-all-devices.webp" class="responsive-image"
                alt="{{ 'seo.fotoGisOnAllDevices' | translate }}">
        </div>
        <div #fromSideAnimation class="col-xl-6 center-text pt-4 from-right-animation">
            <div class="row">
                <div class="col-12 pb-4">
                    <h2 class="header header--700">{{ 'noMore.header' | translate }}</h2>
                </div>
                <div class="col-12 pb-4">
                    <p class="paragraph">{{ 'noMore.text' | translate }}</p>
                </div>
                <div class="col">
                    <a href="https://pro.foto-gis.eu/" target="_blank" class="btn btn--white-hover">{{
                        'noMore.buttonText' | translate }}</a>
                </div>
            </div>
        </div>
    </div>
</section>
<section id="advantages" class="py-5">
    <h2 class="text-center header header--300 pb-5">{{ 'advantages.headert' | translate }}</h2>
    <div id="advantages-container" class="row d-flex align-items-stretch justify-content-center w-75 m-auto">
        <div #advantagesOpacityAnimation class="col-xl-3 col-lg-6 col-sm-8 col-xs-12 my-2 p-0 opacity-animation">
            <div class="h-100 card card--advantages-first-line pt-3 m-2 text-center">
                <div class="card-body p-2">
                    <h3 class="card-title header header--600">{{ 'advantages.card1Header' | translate }}</h3>
                    <p class="card-text text-justify paragraph--300">{{ 'advantages.card1text' | translate }}</p>
                </div>
            </div>
        </div>
        <div #advantagesOpacityAnimation class="col-xl-3 col-lg-6 col-sm-8 col-xs-12 my-2 p-0 opacity-animation">
            <div class="h-100 card card--advantages-first-line pt-3 m-2 text-center">
                <div class="card-body p-2">
                    <h3 class="card-title header header--600">{{ 'advantages.card2Header' | translate }}</h3>
                    <p class="card-text text-justify paragraph paragraph--300">{{ 'advantages.card2Text' | translate }}
                    </p>
                </div>
            </div>
        </div>
        <div #advantagesOpacityAnimation class="col-xl-3 col-lg-6 col-sm-8 col-xs-12 my-2 p-0 opacity-animation">
            <div class="h-100 card card--advantages-first-line pt-3 m-2 text-center">
                <div class="card-body p-2">
                    <h3 class="card-title header header--600">{{ 'advantages.card3Header' | translate }}</h3>
                    <p class="card-text text-justify paragraph paragraph--300">{{ 'advantages.card3Text' | translate }}
                    </p>
                </div>
            </div>
        </div>
        <div #advantagesOpacityAnimation class="col-xl-3 col-lg-6 col-sm-8 col-xs-12 my-2 p-0 opacity-animation">
            <div class="h-100 card card--advantages-first-line pt-3 m-2 text-center">
                <div class="card-body p-2">
                    <h3 class="card-title header header--600">{{ 'advantages.card4Header' | translate }}</h3>
                    <p class="card-text text-justify paragraph paragraph--300">{{ 'advantages.card4Text' | translate }}
                    </p>
                </div>
            </div>
        </div>
        <div #advantagesOpacityAnimation class="col-xl-3 col-lg-6 col-sm-8 col-xs-12 my-2 p-0 opacity-animation">
            <div class="h-100 card card--advantages-second-line pt-3 m-2 text-center">
                <div class="card-body p-2">
                    <h3 class="card-title header header--600">{{ 'advantages.card5Header' | translate }}</h3>
                    <p class="card-text text-justify paragraph paragraph--300">{{ 'advantages.card5Text' | translate }}
                    </p>
                </div>
            </div>
        </div>
        <div #advantagesOpacityAnimation class="col-xl-3 col-lg-6 col-sm-8 col-xs-12 my-2 p-0 opacity-animation">
            <div class="h-100 card card--advantages-second-line pt-3 m-2 text-center">
                <div class="card-body p-2">
                    <h3 class="card-title header header--600">{{ 'advantages.card6Header' | translate }}</h3>
                    <p class="card-text text-justify paragraph paragraph--300">{{ 'advantages.card6Text' | translate }}
                    </p>
                </div>
            </div>
        </div>
        <div #advantagesOpacityAnimation class="col-xl-3 col-lg-6 col-sm-8 col-xs-12 my-2 p-0 opacity-animation">
            <div class="h-100 card card--advantages-second-line pt-3 m-2 text-center">
                <div class="card-body p-2">
                    <h3 class="card-title header header--600">{{ 'advantages.card7Header' | translate }}</h3>
                    <p class="card-text text-justify paragraph paragraph--300">{{ 'advantages.card7Text' | translate }}
                    </p>
                </div>
            </div>
        </div>
        <div #advantagesOpacityAnimation class="col-xl-3 col-lg-6 col-sm-8 col-xs-12 my-2 p-0 opacity-animation">
            <div class="h-100 card card--advantages-second-line pt-3 m-2 text-center">
                <div class="card-body p-2">
                    <h3 class="card-title header header--600">{{ 'advantages.card8Header' | translate }}</h3>
                    <p class="card-text text-justify paragraph paragraph--300">{{ 'advantages.card8Text' | translate }}
                    </p>
                </div>
            </div>
        </div>
        <div #advantagesOpacityAnimation class="col-xl-3 col-lg-6 col-sm-8 col-xs-12 my-2 p-0 opacity-animation">
            <div class="h-100 card card--advantages-third-line pt-3 m-2 text-center">
                <div class="card-body p-2">
                    <h3 class="card-title header header--600">{{ 'advantages.card9Header' | translate }}</h3>
                    <p class="card-text text-justify paragraph paragraph--300">{{ 'advantages.card9Text' | translate }}
                    </p>
                </div>
            </div>
        </div>
        <div #advantagesOpacityAnimation class="col-xl-3 col-lg-6 col-sm-8 col-xs-12 my-2 p-0 opacity-animation">
            <div class="h-100 card card--advantages-third-line pt-3 m-2 text-center">
                <div class="card-body p-2">
                    <h3 class="card-title header header--600">{{ 'advantages.card10Header' | translate }}</h3>
                    <p class="card-text text-justify paragraph paragraph--300">{{ 'advantages.card10Text' | translate }}
                    </p>
                </div>
            </div>
        </div>
        <div #advantagesOpacityAnimation class="col-xl-3 col-lg-6 col-sm-8 col-xs-12 my-2 p-0 opacity-animation">
            <div class="h-100 card card--advantages-third-line pt-3 m-2 text-center">
                <div class="card-body p-2">
                    <h3 class="card-title header header--600">{{ 'advantages.card11Header' | translate }}</h3>
                    <p class="card-text text-justify paragraph paragraph--300">{{ 'advantages.card11Text' | translate }}
                    </p>
                </div>
            </div>
        </div>
        <div #advantagesOpacityAnimation class="col-xl-3 col-lg-6 col-sm-8 col-xs-12 my-2 p-0 opacity-animation">
            <div class="h-100 card card--advantages-third-line pt-3 m-2 text-center">
                <div class="card-body p-2">
                    <h3 class="card-title header header--600">{{ 'advantages.card12Header' | translate }}</h3>
                    <p class="card-text text-justify paragraph paragraph--300">{{ 'advantages.card12Text' | translate }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
<section id="organizer" class="container-fluid">
    <div class="row d-flex justify-content-center align-items-center p-2 p-lg-5 p-md-4">
        <div #organizerFromSideAnimation id="carousel" class="carousel slide my-3 col-xl-5 col-md-8 from-left-animation"
            data-ride="carousel">
            <div class="carousel-inner">
                <div class="carousel-item  justify-content-center align-items active">
                    <img class="d-block responsive-image responsive-image--slider"
                        src="/assets/img/webp/points-on-map.webp" alt="{{ 'seo.pointsOnMap' | translate }}">
                </div>
                <div class="carousel-item  justify-content-center align-items">
                    <img class="d-block responsive-image responsive-image--slider"
                        src="/assets/img/webp/creating-user.webp" alt="{{ 'seo.creatingUser' | translate }}">
                </div>
                <div class="carousel-item  justify-content-center align-items">
                    <img class="d-block responsive-image responsive-image--slider"
                        src="/assets/img/webp/stastistics.webp" alt="{{ 'seo.statisctics' | translate }}">
                </div>
            </div>
            <a class="carousel-control-prev" href="#carousel" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carousel" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
        <div #organizerFromSideAnimation class="my-3 col-xl-5 center-text from-right-animation">
            <div class="row">
                <div class="col-12 center-vertical">
                    <h2 class="header header--700">{{ 'organizer.header' | translate }}</h2>
                </div>
                <div class="col-12">
                    <p>{{ 'organizer.text' | translate }}</p>
                </div>
                <div class="col">
                    <a [routerLink]="['/pricing']" class="btn btn--white-hover">{{ 'organizer.buttonText' | translate
                        }}</a>
                </div>
            </div>

        </div>
        <div #organizerFromSideAnimation
            class="my-3 col-xl-2 d-flex justify-content-center align-items-center h-300 from-right-animation">
            <img class="responsive-image responsive-image--gps" src="/assets/img/webp/foto-gis-pin-map.webp"
                alt="{{ 'seo.fotoGisPinMap' | translate }}">
        </div>
    </div>
</section>
<section id="advise" class="px-2 pt-2 px-lg-5 py-lg-5 px-md-4 py-md-4">
    <h2 class="text-center header header--300 pb-5">
        {{ 'advise.header' | translate }}
    </h2>
    <div id="advise-items-container">
        <div #upAdviceAnimation class="row d-flex justify-content-center align-items-center m-0 up-animation-1">
            <div class="col-xl-4 col-md-10 py-3 px-0">
                <img src="/assets/img/webp/online-training-course.webp"
                    alt="{{ 'seo.onlineTrainingCourse' | translate }}">
            </div>
            <div class="col-xl-8">
                <h3 class="header header--600 pb-3">{{ 'advise.firstHeader' | translate }}</h3>
                <p class="paragraph paragraph--300 pb-3">{{ 'advise.firstText' | translate }}</p>
                <button mat-raised-button (click)="openModalContact()" class="btn mb-4">{{
                    'advise.firstButtonText' | translate }}</button>
            </div>
        </div>
        <div #upAdviceAnimation class="row pt-5 d-flex justify-content-center align-items-center m-0 up-animation-2">
            <div class="col-xl-4 col-md-10 py-3 px-0">
                <img src="/assets/img/webp/one-day-training-on-site.webp"
                    alt="{{ 'seo.oneDayTrainingOnSite' | translate }}">
            </div>
            <div class="col-xl-8">
                <h3 class="header header--600 pb-3">{{ 'advise.secondHeader' | translate }}</h3>
                <p class="paragraph paragraph--300 pb-3">{{ 'advise.secondText' | translate }}</p>
                <button mat-raised-button (click)="openModalContact()" class="btn mb-4">{{
                    'advise.secondButtonText' | translate }}</button>
            </div>
        </div>
    </div>
</section>
<section id="documents" class="container-fluid">
    <div class="row d-flex justify-content-center align-items-center p-2 p-lg-5 p-md-4">
        <div class="my-3 col-xl-5 col-md-8 d-flex justify-content-center align-items-center big-icon">
            <i class="fas fa-file-alt"></i>
        </div>
        <div class="my-3 col-xl-6 center-text">
            <div id="documents-text-container" class="row">
                <div #opacityDocumentsAnimation class="col-12 center-vertical opacity-animation">
                    <h2 class="header header--700">{{ 'documents.header' | translate }}</h2>
                </div>
                <div #opacityDocumentsAnimation class="col opacity-animation documents-btn-container">
                    <div class="row d-flex">
                        <div id="release-notes-btn">
                            <a href="/release-note" class="btn btn--white-hover m-1 custom-width-40">
                                <div class="mobile-btn btn-documents">
                                    <div class="img-mobile d-flex align-items-center">
                                        <i class="far fa-file-pdf"></i>
                                    </div>
                                    <div class="text-mobile">
                                        <span>{{ 'releaseNote.title' | translate }}</span>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div id="price-sheet-btn">
                            <a *ngIf="getItem('lang')=='en'" href="/assets/doc/Foto-GIS_Preis-Tabelle_EN.pdf"
                                target="_blank" class="btn btn--white-hover m-1 custom-width-40">
                                <div class="mobile-btn btn-documents">
                                    <div class="img-mobile d-flex align-items-center">
                                        <i class="far fa-file-pdf"></i>
                                    </div>
                                    <div class="text-mobile">
                                        <span>{{ 'documents.price-btn' | translate }}</span>
                                    </div>
                                </div>
                            </a>
                            <a *ngIf="getItem('lang')=='es'" href="/assets/doc/Foto-GIS_Preis-Tabelle_ES.pdf"
                                target="_blank" class="btn btn--white-hover m-1 custom-width-40">
                                <div class="mobile-btn btn-documents">
                                    <div class="img-mobile d-flex align-items-center">
                                        <i class="far fa-file-pdf"></i>
                                    </div>
                                    <div class="text-mobile">
                                        <span>{{ 'documents.price-btn' | translate }}</span>
                                    </div>
                                </div>
                            </a>
                            <a *ngIf="getItem('lang')=='fr'" href="/assets/doc/Foto-GIS_Preis-Tabelle_EN.pdf"
                                target="_blank" class="btn btn--white-hover m-1 custom-width-40">
                                <div class="mobile-btn btn-documents">
                                    <div class="img-mobile d-flex align-items-center">
                                        <i class="far fa-file-pdf"></i>
                                    </div>
                                    <div class="text-mobile">
                                        <span>{{ 'documents.price-btn' | translate }}</span>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="row d-flex">
                        <div id="user-manual-tablet-btn">
                            <a *ngIf="getItem('lang')=='en'" href="/assets/doc/Foto-GIS_Tablet-HowTo_EN.pdf"
                                target="_blank" class="btn btn--white-hover m-1">
                                <div class="mobile-btn">
                                    <div class="img-mobile d-flex align-items-center">
                                        <i class="far fa-file-pdf"></i>
                                    </div>
                                    <div class="text-mobile">
                                        <span>{{ 'systemTrio.appTabletDocuButton' | translate }}</span>
                                    </div>
                                </div>
                            </a>
                            <a *ngIf="getItem('lang')=='fr'" href="/assets/doc/Foto-GIS_Tablet-HowTo_FR.pdf"
                                target="_blank" class="btn btn--white-hover m-1">
                                <div class="mobile-btn">
                                    <div class="img-mobile d-flex align-items-center">
                                        <i class="far fa-file-pdf"></i>
                                    </div>
                                    <div class="text-mobile">
                                        <span>{{ 'systemTrio.appTabletDocuButton' | translate }}</span>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div id="user-manual-smaprtphone-btn">
                            <a *ngIf="getItem('lang')=='en'" href="/assets/doc/Foto-GIS_Smartphone-HowTo_EN.pdf"
                                target="_blank" class="btn btn--white-hover m-1">
                                <div class="mobile-btn">
                                    <div class="img-mobile d-flex align-items-center">
                                        <i class="far fa-file-pdf"></i>
                                    </div>
                                    <div class="text-mobile">
                                        <span>{{ 'systemTrio.appSmartDocuButton' | translate }}</span>
                                    </div>
                                </div>
                            </a>
                            <a *ngIf="getItem('lang')=='es'" href="/assets/doc/Foto-GIS_Smartphone-HowTo_ES.pdf"
                                target="_blank" class="btn btn--white-hover m-1">
                                <div class="mobile-btn">
                                    <div class="img-mobile d-flex align-items-center">
                                        <i class="far fa-file-pdf"></i>
                                    </div>
                                    <div class="text-mobile">
                                        <span>{{ 'systemTrio.appSmartDocuButton' | translate }}</span>
                                    </div>
                                </div>
                            </a>
                            <a *ngIf="getItem('lang')=='fr'" href="/assets/doc/Foto-GIS_Smartphone-HowTo_FR.pdf"
                                target="_blank" class="btn btn--white-hover m-1">
                                <div class="mobile-btn">
                                    <div class="img-mobile d-flex align-items-center">
                                        <i class="far fa-file-pdf"></i>
                                    </div>
                                    <div class="text-mobile">
                                        <span>{{ 'systemTrio.appSmartDocuButton' | translate }}</span>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="row d-flex">
                        <div id="user-manual-web-btn">
                            <a *ngIf="getItem('lang')=='en'" href="/assets/doc/NGN_Foto-GIS_en.pdf" target="_blank"
                                class="btn btn--white-hover m-1">
                                <div class="mobile-btn">
                                    <div class="img-mobile d-flex align-items-center">
                                        <i class="far fa-file-pdf"></i>
                                    </div>
                                    <div class="text-mobile">
                                        <span>{{ 'systemTrio.organizerWeDocuButton' | translate }}</span>
                                    </div>
                                </div>
                            </a>
                            <a *ngIf="getItem('lang')=='es'" href="/assets/doc/NGN_Foto-GIS_en.pdf" target="_blank"
                                class="btn btn--white-hover m-1">
                                <div class="mobile-btn">
                                    <div class="img-mobile d-flex align-items-center">
                                        <i class="far fa-file-pdf"></i>
                                    </div>
                                    <div class="text-mobile">
                                        <span>{{ 'systemTrio.organizerWeDocuButton' | translate }}</span>
                                    </div>
                                </div>
                            </a>
                            <a *ngIf="getItem('lang')=='fr'" href="/assets/doc/NGN_Foto-GIS_fr.pdf" target="_blank"
                                class="btn btn--white-hover m-1">
                                <div class="mobile-btn">
                                    <div class="img-mobile d-flex align-items-center">
                                        <i class="far fa-file-pdf"></i>
                                    </div>
                                    <div class="text-mobile">
                                        <span>{{ 'systemTrio.organizerWeDocuButton' | translate }}</span>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section id="reference" class="p-5">
    <h2 class="text-center header header--300 pt-2 pb-5">{{ 'reference.header' | translate }}</h2>
    <div class="row px-2 px-lg-5 px-md-4">
        <div *ngIf="references.length != 0" id="referenceCarousel"
            class="carousel carousel-multiple-item slide w-100 pb-5" data-ride="carousel">
            <div class="carousel-inner w-100 h-100" role="listbox">
                <div class="carousel-item carousel-item-multiple-item" [ngClass]="{'active': item.id == 1}"
                    *ngFor="let item of references">
                    <div class="col-xl-4 col-lg-6 col-md-12">
                        <div class="card card-body p-4">
                            <p class="card-text text-justify">„{{ item.text }}“</p>
                            <p class="card-text paragraph paragraph--italic">{{ item.signature }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <a class="carousel-control-prev w-auto" href="#referenceCarousel" role="button" data-slide="prev">
                <img src="../../assets/img/webp/arrow-blue-left.webp" alt="{{ 'seo.arrowBlueLeft' | translate }}">

                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next w-auto" href="#referenceCarousel" role="button" data-slide="next">
                <img src="../../assets/img/webp/arrow-blue-right.webp" alt="{{ 'seo.arrowBlueRight' | translate }}">
                <span class="sr-only">Next</span>
            </a>
        </div>
    </div>
</section>
<section id="moreCustomers" class="p-5">
    <h2 class="text-center header header--300 pt-2 pb-5">{{ 'reference.moreCustomersHeader' | translate }}</h2>
    <div class="row px-2 px-lg-5 px-md-4">
        <div class="scroll-container">
            <div class="scrolling-wrapper">
                <img *ngFor="let img of allCustomerLogos" [src]="img" loading="lazy" alt="Customer logo">
            </div>
        </div>
    </div>
</section>
<section id="aboutUs" class="px-2 py-5 px-lg-5 px-md-4">
    <h2 class="text-center header header--300">
        {{ 'about.header' | translate }}
    </h2>
    <div class="row mb-5 pt-5 d-flex justify-content-center m-0">
        <div class="col-xl-8 col-md-10">
            <p>
                {{ 'about.ngnText' | translate }}
            </p>

            <a href="https://www.ngn-itsolutions.eu/" target="_blank">
                <button class="btn btn--white-hover">{{ 'about.ngnButtonText' | translate }}</button>
            </a>
        </div>
        <div class="col-xl-4 col-md-8 col-sm-10 d-flex justify-content-center align-items-center">
            <img class="responsive-image py-4" src="/assets/img/webp/ngn-it-solutions-logo.webp"
                alt="{{ 'seo.ngnItSolutionsLogo' | translate }}">
        </div>
    </div>
    <div class="row text-center m-0">
        <img class="quote" src="/assets/img/webp/quote.webp" alt="{{ 'seo.quote' | translate }}">
        <p class="quote-text col-12 header header--300">
            {{ 'about.quote' | translate }}
        </p>
        <span class="col-12 text-center">
            {{ 'about.quoteSignature' | translate }}
        </span>
    </div>
</section>
<section id="mozaik"></section>
<section id="contact" class="px-2 px-lg-5 px-md-4">
    <div class="row m-0">
        <div id="contact-details" class="col-xl-5 col-12 py-4">
            <h3 class="header header--600">
                {{ 'contact.header' | translate }}
            </h3>
            <p>
                <span class="paragraph paragraph--600">
                    {{ 'contact.name' | translate }}
                </span><br>
                <a *ngIf="getItem('lang')=='en'" href="mailto:derek.bogdan@foto-gis.com">{{
                    'contact.email' |
                    translate }}</a>
                <a *ngIf="getItem('lang')=='es'" href="mailto:simon.bangert@ngn-itsolutions.eu">{{
                    'contact.email' |
                    translate }}</a>
                <a *ngIf="getItem('lang')=='fr'" href="mailto:simon.bangert@ngn-itsolutions.eu">{{
                    'contact.email' | translate }}</a><br>
                {{ 'contact.tel' | translate }}
                <a *ngIf="getItem('lang')=='en'" href="tel:+49 97 61 / 80049 73">{{ 'contact.nrTel' | translate }}</a>
                <a *ngIf="getItem('lang')=='es'" href="tel:+49 97 61 / 80049 73">{{ 'contact.nrTel' | translate
                    }}</a>
                <a *ngIf="getItem('lang')=='fr'" href="tel:+49 97 61 / 80049 73">{{ 'contact.nrTel' | translate
                    }}</a>
                <br>
                {{ 'contact.hours' | translate }}
            </p>
            <img class="responsive-image responsive-image--gps py-4" src="/assets/img/webp/foto-gis-pin-map.webp"
                alt="{{ 'seo.fotoGisPinMap' | translate }}">
            <div class="col-12 social-media">
                <a href="https://www.facebook.com/NGN-It-Solutions-GmbH-112339510510207/" target="_blank"><img
                        src="/assets/img/webp/facebook.webp" alt="{{ 'seo.facebook' | translate }}"></a>
                <a href="https://www.linkedin.com/company/ngn-it-solutions-gmbh/?viewAsMember=true" target="_blank"><img
                        src="/assets/img/webp/linkedin.webp" alt="{{ 'seo.linkedin' | translate }}"></a>
                <a href="https://www.xing.com/companies/ngnitsolutionsgmbh" target="_blank"><img
                        src="/assets/img/webp/xk.webp" alt="{{ 'seo.xk' | translate }}"></a>
            </div>
        </div>
        <div class="col-xl-7 col-12 py-4">
            <div class="col-12 pb-5 px-0">
                <h3 class="pb-4">
                    {{ 'contact.salesManText' | translate }}
                </h3>
                <button mat-raised-button (click)="openModalContact()" class="btn btn--white-hover">
                    {{ 'contact.salesManButtonText' | translate }}
                </button>
            </div>
            <div class="col-12 pb-5 px-0">
                <h3 class="pb-4">
                    {{ 'contact.technicText' | translate }}
                </h3>
                <button mat-raised-button (click)="openModalContact()" class="btn btn--white-hover">
                    {{ 'contact.technicButtonText' | translate }}
                </button>
            </div>
        </div>
    </div>
</section>

<app-scroll-to-top></app-scroll-to-top>
